import { Routes, Route } from "react-router-dom";
import BankTransactionsConatiner from "./Components/bankTransactions/BankTransactionsConatiner";
import DataTableAllocation from "./Components/documents/bankStatementlistAllocation";
import CashAllocation from "./Components/CashAllocation/CashAllocation";
import Login from "./containers/login";
import ROUTES from "./utils/routes";
import PrivateRoutes from "./PrivateRoutes";
import ForgetPassword from "./containers/forgetPassword";
import UserList from "./containers/administration/userMaintainance/usersList";
import ManageUser from "./containers/administration/userMaintainance/manageUser";
import CashTracker from "./Components/CashTracker/CashTracker";
import AssignPolicyHandler from "./Components/AssignPolicyHandler/AssignPolicyHandler";
import EntityContainer from "./Components/EntityTableMaintainance/EntityContainer";
import LobContainer from "./Components/Lob/LobContainer";
import ScmContainer from "./Components/SCMPartners/ScmContainer";
import BindingAgreementContainer from "./Components/BindingAgreements/BindingAgreement";
import { WorkList } from "./Components/WorkList/WorkList";
import CorrectionTypeContainer from "./Components/CorrectionTableMaintaince/CorrectionTableContainer";
import AllocationStatusContainer from "./Components/AllocationStatus/AllocationStatus";
import BrokerContainer from "./Components/Broker/BrokerContainer";
import CashTransferContainer from "./Components/CashTransfer/CashTransferContainer";
import PolicyContainer from "./Components/Policy/PolicyContainer";
import AgedebtActionContainer from "./Components/AgeDebtAction/AgedebtActionContainer";
import AgedebtCategoryContainer from "./Components/AgeDebtCategory/AgedebtCategoryContainer";
import CurrencyTableContainer from "./Components/CurrencyTableMaintainance/CurrencyTableContainer";
import BankExchangeRate from "./Components/BankExchangeRate/BankExchangeRate";

import PremiumTableContainer from "./Components/PremiumTable/PremiumTable";
import UploadFilesConatiner from "./Components/UploadFiles/UploadFilesContainer";

// import CrossAllocation from './Components/CashAllocation/CrossAllocation.jsx';
// import Refund from './Components/CashAllocation/Refund.jsx';

// import { BankReconciliation } from "./Components/BankReconciliation/BankReconciliation";
import { BankReconciliationView } from "./Components/BankReconciliation/BankReconciliationView";
import { LockUnlockContainer } from "./Components/AdministrationLockUnlock/LockUnlockContainer";
import { StatementUpLoad } from "./Components/StatementUpload/StatementUpLoad.jsx";
import { AgedReport } from "./Components/AgedReports/AgedReport";
import { AgedeptDetails } from "./Components/AgedReports/AgedeptDetails";
import ExceptionReport from "./Components/BDXPaymentUpdates/ExceptionReport.js";
import Dashboard from "./Components/Dashboard/Dashboard";
import TreasuryList from "./Components/BDXPaymentUpdates/TreasuryList.js";
import CoversheetList from "./Components/BDXPaymentUpdates/CoversheetList.js";
import PayoutSummary from "./Components/BDXPaymentUpdates/PayoutSummary.js";
import PremiumBDX from "./Components/BDXPaymentUpdates/PremiumBDX.js";

import DisplayReportByReportName from "./Components/Reports/DisplayReportByReportName";
import SLAContainer from "./Components/SLA/SLAContainer.js";
import ParticipatingInsurerContainer from "./Components/ParticipatingInsurer/ParticipatingInsurerContainer.js";

import EscalationContainer from "./Components/Escalation/EscalationContainer.js";
import WorkflowContainer from "./Components/AdministrationWorkflow/Workflow.js";
import AccountingMonthList from "./Components/AccountingMonthEnd/AccountingMonthList.jsx";
import TxnCategoryContainer from "./Components/TxnCategory/TxnCategoryContainer.js";
import TxnStatusContainer from "./Components/TxnStatus/TxnStatusContainer.js";
import FileManagement from "./Components/FileManagement/FileManagement.js";
import PublicRoutes from "./PublicRoutes.jsx";

import { AgedDebtDueView } from "./Components/AgedDebtDue/AgedDebtDueView";
import ChaserIndicatorContainer from "./Components/ChaserIndicator/ChaserIndicatorContainer.js";

import ChaserConatiner from "./Components/Chaser/ChaserContainer.jsx";
import EmailContainer from "./Components/Email/EmailContainer.jsx";
import UserPermissionContainer from "./Components/UserPermissionContainer/UserPermissionContainer.js";
import WorkflowDashboardContainer from "./Components/WorkflowDashboard/WorkflowDashboardContainer.jsx";

const MyRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicRoutes />}>
        <Route
          exact
          path={ROUTES.HOME}
          element={<Login />}
        />

        <Route
          exact
          path={ROUTES.FORGETPASSWORD}
          element={<ForgetPassword />}
        />
      </Route>

      <Route element={<PrivateRoutes />}>
        <Route
          exact
          path={ROUTES.MUBST}
          element={<BankTransactionsConatiner />}
        />
        <Route
          exact
          path={ROUTES.MUUF}
          element={<UploadFilesConatiner />}
        />
        <Route
          exact
          path={ROUTES.MUSU}
          element={<StatementUpLoad />}
        />
        <Route
          exact
          path={ROUTES.MUABT}
          element={<DataTableAllocation />}
        />
        <Route
          exact
          path={ROUTES.MUCASHTRACKER}
          element={<CashTracker />}
        />
        <Route
          exact
          path={ROUTES.AUM}
          element={<UserList />}
        />
        <Route
          exact
          path={ROUTES.ALU}
          element={<LockUnlockContainer />}
        />
        <Route
          path={ROUTES.WLAI}
          element={<WorkList />}
        />
        {/* <Route exact path={ROUTES.MUBR} element={<BankReconciliation />} /> */}
        <Route
          exact
          path={ROUTES.MUBR}
          element={<BankReconciliationView />}
        />
        <Route
          exact
          path={ROUTES.BTAM}
          element={<AccountingMonthList />}
        />

        <Route
          exact
          path={ROUTES.AUMAU}
          element={<ManageUser type="add" />}
        />
        <Route
          exact
          path={ROUTES.AUMEU}
          element={<ManageUser type="edit" />}
        />
        <Route
          exact
          path={ROUTES.AUMVU}
          element={<ManageUser type="view" />}
        />
        <Route
          path="/cash-allocation"
          element={<CashAllocation />}
        />
        <Route
          exact
          path={ROUTES.AETM}
          element={<EntityContainer />}
        />
        <Route
          exact
          path={ROUTES.LOBETM}
          element={<LobContainer />}
        />
        <Route
          exact
          path={ROUTES.SCMTM}
          element={<ScmContainer />}
        />
        <Route
          exact
          path={ROUTES.BATM}
          element={<BindingAgreementContainer />}
        />
        <Route
          exact
          path={ROUTES.CTTM}
          element={<CorrectionTypeContainer />}
        />
        <Route
          exact
          path={ROUTES.ASTM}
          element={<AllocationStatusContainer />}
        />
        <Route
          exact
          path={ROUTES.BTM}
          element={<BrokerContainer />}
        />
        {/* <Route
          exact
          path={ROUTES.CTM}
          element={<CashTransferContainer />}
        /> */}
        <Route
          exact
          path={ROUTES.PTM}
          element={<PolicyContainer />}
        />
        <Route
          exact
          path={ROUTES.CYTM}
          element={<CurrencyTableContainer />}
        />
        <Route
          exact
          path={ROUTES.BETM}
          element={<BankExchangeRate />}
        />

        {/* // Reports start */}
        <Route
          path="/Reports/:report_name"
          element={<DisplayReportByReportName />}
        />
        {/* // Reports End */}

        <Route
          exact
          path={ROUTES.PMTM}
          element={<PremiumTableContainer />}
        />

        <Route
          exact
          path={ROUTES.Dashboard}
          element={<Dashboard />}
        />

        <Route
          exact
          path={ROUTES.ExceptionReport}
          element={<ExceptionReport />}
        />

        <Route
          exact
          path={ROUTES.TreasuryList}
          element={<TreasuryList />}
        />
        <Route
          exact
          path={ROUTES.CoversheetList}
          element={<CoversheetList />}
        />
        <Route
          exact
          path={ROUTES.PayoutSummary}
          element={<PayoutSummary />}
        />
        <Route
          exact
          path={ROUTES.PremiumBDX}
          element={<PremiumBDX />}
        />

        <Route
          exact
          path={ROUTES.SLA}
          element={<SLAContainer />}
        />
        <Route
          exact
          path={ROUTES.ParticipatingInsurer}
          element={<ParticipatingInsurerContainer />}
        />
        <Route
          exact
          path={ROUTES.Escalation}
          element={<EscalationContainer />}
        />
        <Route
          exact
          path={ROUTES.TxnCategory}
          element={<TxnCategoryContainer />}
        />
        <Route exact path={ROUTES.TxnStatus} element={<TxnStatusContainer />} />
        <Route
          exact
          path={ROUTES.AdministrationWorkflow}
          element={<WorkflowContainer />}
        />
        <Route
          exact
          path={ROUTES.FileManagement}
          element={<FileManagement />}
        />
        {/* <Route 
          exact 
          path={ROUTES.BTAR} 
          element={<AgedReport />} 
        /> */}
        <Route 
          exact 
          path={ROUTES.BTARD} 
          element={<AgedeptDetails />} 
        />
        <Route
          exact
          path={ROUTES.AgedDebtDue}
          element={<AgedDebtDueView />}
        />
        {/* <Route 
          exact 
          path={ROUTES.BTAR} 
          element={<AgedReport />} 
        /> */}
        <Route 
          exact 
          path={ROUTES.BTARD} 
          element={<AgedeptDetails />} 
        />
        <Route 
          exact 
          path={ROUTES.CCC} 
          element={<ChaserConatiner />} 
        />
        <Route
          exact
          path={ROUTES.ChaserIndicator}
          element={<ChaserIndicatorContainer />}
        />
        <Route
          exact
          path={ROUTES.APH}
          element={<AssignPolicyHandler />}
        />
        <Route
          exact
          path={ROUTES.ADA}
          element={<AgedebtActionContainer />}
        />
        <Route
          exact
          path={ROUTES.ADC}
          element={<AgedebtCategoryContainer />}
        />
        <Route
          exact
          path={ROUTES.EMAIL}
          element={<EmailContainer />}
        />
        <Route
          exact
          path={ROUTES.WORKFLOWDASHBOARD}
          element={<WorkflowDashboardContainer />}
        />

        <Route
          exact
          path={ROUTES.APH}
          element={<AssignPolicyHandler />}
        />
        <Route 
          exact 
          path={ROUTES.UPC} 
          element={<UserPermissionContainer />} 
        />
        <Route
          path={"*"}
          element={<></>}
        />
      </Route>
    </Routes>
  );
};

export default MyRoutes;
